// Drop-in replacement hook for the broken AuthContext
import { useAuthStore } from '../stores/authStore';
import { RoleLevel, ROLE_LABELS } from '../types/rbacImproved';
export const useZustandAuth = () => {
    const store = useAuthStore();
    // Create a compatible interface with the old AuthContext
    return {
        // State
        user: store.user,
        isAuthenticated: store.isAuthenticated,
        isLoading: store.isLoading,
        permissions: store.permissions,
        roleLevel: store.user?.roleLevel ?? null,
        roleName: store.user ? ROLE_LABELS[store.user.roleLevel] : null,
        // Permission functions
        hasPermission: store.hasPermission,
        hasAnyPermission: store.hasAnyPermission,
        hasAllPermissions: store.hasAllPermissions,
        canAccessPage: (pagePermission) => store.hasPermission(pagePermission),
        canUseComponent: (componentPermission) => store.hasPermission(componentPermission),
        canPerformAction: (actionPermission) => store.hasPermission(actionPermission),
        // Auth actions
        login: store.login,
        logout: store.logout,
        register: async (userData) => {
            // Placeholder for register function
            return { success: false, error: 'Register not implemented in Zustand store yet' };
        },
        refreshToken: store.refreshTokens,
        // Role management (simplified)
        canManageUser: (targetUserId, targetRole) => {
            return store.user ? store.user.roleLevel > targetRole : false;
        },
        getMaxAssignableRole: () => {
            return store.user ? store.user.roleLevel - 1 : RoleLevel.GUEST;
        },
        // Debug helper
        debugAuth: store.getAuthDebugInfo,
        getAuthDebugInfo: store.getAuthDebugInfo
    };
};
